export const investorInversionMarks = [
  {
    value: 10000,
    label: '$10 MIL',
  },
  {
    value: 500000,
    label: '$500 MIL',
  },
];

export const factoradoInversionMarks = [
  {
    value: 10000,
    label: '$10 MIL',
  },
  {
    value: 500000,
    label: '$500 MIL',
  },
];

export const plazoMarks = [
  {
    value: 30,
    label: '30 DÍAS',
  },
  {
    value: 120,
    label: '120 DÍAS',
  },
];